import Component from "../../lib/component";
import { MixinTemplateRenderable } from "../../lib/mixins/template_renderable";
import { registerTemplateHelpers } from "./template_helpers";

export const TemplatorConfig = {
  componentTypeKey: "Templator",
  baseHtmlClass: "templator",
  selector: ".templator",

  datasetConfigKey: "templator__config",
  templateEndpointDatasetConfigKey: "template_endpoint", // An endpoint to fetch a Handlebars template from (relative or full URL).
  dataEndpointDatasetConfigKey: "data_endpoint", // An endpoint to fetch JSON data for the template from (relative or full URL).
  templateStringDatasetConfigKey: "template_string", // A Handlebars template that is passed in as a string.
  templateDataDatasetConfigKey: "template_data", // Data for the template that is passed in directly.
  targetSelectorDatasetConfigKey: "target_selector", // The selector for the element that will append the compiled template.
  autoRenderDatasetConfigKey: "auto_render", // Whether to automatically render the template when the data changes.
};

export class Templator extends Component {
  static get config() {
    return TemplatorConfig;
  }

  constructor(id_or_element) {
    super({ element: id_or_element, config: Templator.config });

    // Apply the template rendering mixin
    // This mixin provides the template rendering functionality.
    MixinTemplateRenderable(this);
    registerTemplateHelpers(this);

    // Get configuration from dataset attributes
    this.setDatasetConfig(Templator.config.datasetConfigKey);

    const templateEndpoint = this.getDatasetConfigValue(
      Templator.config.templateEndpointDatasetConfigKey,
    );
    const dataEndpoint = this.getDatasetConfigValue(
      Templator.config.dataEndpointDatasetConfigKey,
    );
    const templateString = this.getDatasetConfigValue(
      Templator.config.templateStringDatasetConfigKey,
    );
    const templateData = this.getDatasetConfigValue(
      Templator.config.templateDataDatasetConfigKey,
    );
    const targetSelector = this.getDatasetConfigValue(
      Templator.config.targetSelectorDatasetConfigKey,
    );
    const autoRender =
      this.getDatasetConfigValue(
        Templator.config.autoRenderDatasetConfigKey,
      ) !== false;

    // Initialize the template renderer
    this.initializeTemplate({
      templateEndpoint: templateEndpoint,
      dataEndpoint: dataEndpoint,
      templateString: templateString,
      templateData: templateData,
      targetSelector: targetSelector,
      autoRender: autoRender,
    });

    this.render();
  }

  render() {
    // We're using requestAnimationFrame to ensure that the rendered template was already inserted into the DOM in a previous tick.
    // This is necessary to ensure that the CSS transitions work correctly.
    requestAnimationFrame(() => {
      this.swapHtmlClassStates(
        !!this.templateIsRendered,
        "rendered",
        "unrendered",
      );
    });
  }
}
